import {
  GET_DASHBOARD_DATA_SUCCESS,
  GET_TRANSACTION_DATA_SUCCESS,
  GET_TRANSACTION_DATA,
  GET_AUM_DATA_SUCCESS,
  GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS,
  GET_DASHBOARD_AUM_DATA_SUCCESS,
  GET_SIP_SUMMARY_DATA_SUCCESS,
  GET_NFO_SCHEMES_SUCCESS,
  GET_DOMAIN_SUCCESS,
  GET_NFO_SCHEMES,
} from "../types";

export function dashboard(
  state = { summaryData: [], aumData: [], nfoSchemes: [] },
  action
) {
  switch (action.type) {
    case GET_DASHBOARD_DATA_SUCCESS: {
      const { pending, expired, approved,PhysicalTransactions } = action.body;
      return { ...state, transactionSummary: { pending, expired, approved ,PhysicalTransactions} };
    }
    case GET_DOMAIN_SUCCESS: {
      const { DtData, Table2 } = action.body;
      return { ...state, emaildomain: DtData, emailhost: Table2 };
    }
    case GET_DASHBOARD_AUM_DATA_SUCCESS: {
      return { ...state, dashboardAUMData: action.body };
    }
    case GET_SIP_SUMMARY_DATA_SUCCESS: {
      return { ...state, sipSummaryData: action.body };
    }
    case GET_TRANSACTION_DATA: {
      return { ...state, summaryData: [] };
    }
    case GET_NFO_SCHEMES_SUCCESS: {
      return { ...state, nfoSchemes: action.body };
    }
    case GET_AUM_DATA_SUCCESS: {
      const { DtData } = action.body;
      return {
        ...state,
        aumData: action.body,
      };
    }
    case GET_FREQUENT_MAIL_BACK_REQUEST_SUCCESS: {
      return state;
    }
    default:
      return state;
  }
}
